import 'aos/dist/aos.css';
import AOS from 'aos';
import './HeroSection.css';
import React from 'react'
import { useSpring, animated } from 'react-spring'
import SocialLinks from './SocialLinks/SocialLinks';
import Resume from './Resume/Resume';
import ReactTooltip from 'react-tooltip';

const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2]
const trans1 = (x, y) => `translate3d(${x / 10}px,${y / 10}px,0)`
const trans2 = (x, y) => `translate3d(${x / 8 + 35}px,${y / 8 - 230}px,0)`
const trans3 = (x, y) => `translate3d(${x / 6 - 150}px,${y / 6 - 200}px,0)`
const trans4 = (x, y) => `translate3d(${x / 3.5 + 200}px,${y / 3.5}px,0)`
const trans5 = (x, y) => `translate3d(${x / 5 - 100}px,${y / 5 + 38}px,0)`
const trans6 = (x, y) => `translate3d(${x / 8 + 300}px,${y / 8 - 120}px,0)`
const trans7 = (x, y) => `translate3d(${x / 8 - 220}px,${y / 8 - 120}px,0)`
const trans8 = (x, y) => `translate3d(${x / 5 - 200}px,${y / 5 + 90}px,0)`
const trans9 = (x, y) => `translate3d(${x / 5 - 100}px,${y / 5 + 100}px,0)`




const HeroSection = () => {

      const [props, set] = useSpring(() => ({ xy: [0, 0], config: { mass: 10, tension: 550, friction: 140 } }))

      AOS.init();

      return (
            <section data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos="fade-up" id='about' style={{height:'800px'}} className='mt-5'>
                  <div className="container top-header">

                        <div className="d-sm-none d-md-none">
                                    <img src='https://i.ibb.co/kJ1bHwm/portfolio.png' className='img-fluid mx-auto d-block' width={300} style={{ borderRadius: '50%' }} alt="" />
                                    <SocialLinks />
                                    <Resume />
                        </div>

                        <div className="row mt-5">

                              <div className="col-sm-6">
                                    <h1 className='text-white text-center text-uppercase fs-2'>Welcome to <span className='brand link'>Eftykhar Rahman</span>'s profile!</h1>
                                    <p className="text-center text-muted mt-3 fs-5">I am Eftykhar Rahman. But you will find me everywhere with the handle name <b>Raufu Prezens</b>. I'm a self-taught Full Stack Web Developer.</p>
                                    <div className="d-none d-sm-block">
                                          <SocialLinks />
                                          <Resume />
                                    </div>
                              </div>

                              <div style={{height:'300px'}} className="col-sm-6 d-none d-sm-block">
                                    <ReactTooltip place="top" type="info" effect="float" />
                              
                                    <div class="card-container mt-5" onMouseMove={({ clientX: x, clientY: y }) => set({ xy: calc(x, y) })}>
                                                <animated.div data-tip="Hi! I'm Raufu" class="card1 ms-5" style={{ transform: props.xy.interpolate(trans1) }} />
                                                <animated.div data-tip="I am experienced in React JS framework" class="card2 mt-5" style={{ transform: props.xy.interpolate(trans2) }} />
                                                <animated.div data-tip="and also in MongoDB" class="card3 mt-5" style={{ transform: props.xy.interpolate(trans3) }} />
                                                <animated.div data-tip="well versed in Node JS" class="card4 mt-5" style={{ transform: props.xy.interpolate(trans4) }} />
                                                <animated.div data-tip="proficient in BootStrap5" class="card5 mt-5" style={{ transform: props.xy.interpolate(trans5) }} />
                                                <animated.div data-tip="Tailwind CSS is one of my favorite" class="card6 mt-5" style={{ transform: props.xy.interpolate(trans6) }} />
                                                <animated.div data-tip="mostly use Firebase for authentication" class="card7 mt-5" style={{ transform: props.xy.interpolate(trans7) }} />
                                                <animated.div data-tip="use Python for fun" class="card8 mt-5" style={{ transform: props.xy.interpolate(trans8) }} />
                                                <animated.div data-tip="love to use Gatsby" class="card9 mt-5" style={{ transform: props.xy.interpolate(trans9) }} />
                                    </div>

                              </div>
                              
                        </div>

                  </div>


            </section>
      );
};

export default HeroSection;